import { createContext, useContext } from "react";

import { AccountState } from "features/Account/types";

export const AccountContext = createContext<AccountState | null>(null);

export const useAccountContext = (): AccountState => {
    const state = useContext(AccountContext);

    if (!state) {
        throw new Error("useAccountContext должен использоваться внутри Account");
    }

    return state;
};
